import { caseItems } from '@/mocks/homeData';

export default function CaseSection() {
  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider mb-3">
            客户案例
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            久久草的成功故事
          </h2>
          <p className="max-w-xl mx-auto text-sm md:text-base text-foreground-600 leading-relaxed">
            用心服务每一个项目，用品质赢得客户信赖
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {caseItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-400 hover:border-accent-200"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-600 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="px-3 py-1 text-xs font-medium rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-800">
                    {item.location}
                  </span>
                  <span className="px-3 py-1 text-xs font-medium rounded-full bg-accent-500/90 backdrop-blur-sm text-background-50">
                    {item.area}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-accent-600 transition-colors duration-300">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}